import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { unfolder, urlValue, useTranslate } from '../lib';

const SearchCampaign = ({ onCampaignSelect, searchResultsContainer, showSearch, setShowSearch }) => {
  const [campaigns, setCampaigns] = useState([]);
  const [search, setSearch] = useState('');         // ← usamos "search" como único término
  const [loading, setLoading] = useState(false);
  const { t } = useTranslate();
  const containerRef = useRef(null);

  const fetchCampaigns = async (term) => {
    try {
      setLoading(true);
      const token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey')?.token;
      const id    = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey')?.id;

      const res = await axios.get(`${urlValue}/studio/project/camp/campaing`, {
        params: { q: term || '' },
        headers: { user: id, 'access-token': token },
        withCredentials: true
      });

      const data = Array.isArray(res.data) ? res.data : res.data?.data || [];
      setCampaigns(data);
    } catch (err) {
      console.error('Error loading campaigns', err);
      setCampaigns([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!showSearch) return;
    const t = setTimeout(() => fetchCampaigns(search), 300);
    return () => clearTimeout(t);
  }, [search, showSearch]);

  useEffect(() => {
    if (!showSearch) {
      setSearch('');
      setCampaigns([]);
    }
  }, [showSearch]);

  const handlePick = async (campaign) => {
    try {
      const token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey')?.token;
      const id    = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey')?.id;
      const commonCfg = { headers: { user: id, 'access-token': token }, withCredentials: true };

      let res = null;
      try {
        res = await axios.get(`${urlValue}/studio/project/campaign/${campaign.id}/projects`, commonCfg);
      } catch {}

      const normalize = (payload) => {
        const body = payload ?? [];
        return Array.isArray(body) ? body
          : Array.isArray(body?.data) ? body.data
          : Array.isArray(body?.projects) ? body.projects
          : Array.isArray(body?.data?.projects) ? body.data.projects
          : Array.isArray(body?.rows) ? body.rows
          : [];
      };

      let raw = normalize(res?.data);

      if (!raw.length) {
        try {
          const res2 = await axios.get(`${urlValue}/studio/project/camp/project-campaing/${campaign.id}`, commonCfg);
          raw = normalize(res2?.data);
        } catch {}
      }

      const projects = raw
        .map(p => ({
          id:   p?.id ?? p?.project_id ?? p?.project?.id,
          name: p?.name ?? p?.project_name ?? p?.project?.name,
          type: p?.type ?? p?.project?.type ?? null,
        }))
        .filter(x => x.id && x.name);

      if (!projects.length) {
        console.warn('No projects found in this campaign', campaign.id, 'raw=', raw);
        alert('No projects available for this campaign.')
        return;
      }

      onCampaignSelect?.({ campaign, projects });
      setShowSearch(false);
      
    } catch (e) {
      console.error('Error loading projects by campaign', e);
    }
  };

  if (!showSearch) return null;

  return (
    <div
      ref={containerRef}
      style={{
        position: 'relative',
        width: '100%',
        background: 'white',
        padding: 10,
        borderRadius: 10,
        boxShadow: '1px 1px 3px rgba(0,0,0,.35)',
        marginTop: 10,
        zIndex: 1000
      }}
    >
      <div style={{fontSize: 9, color: '#535353', textTransform: 'uppercase', marginTop: 5}}>
        {t('menu.searchByCampaign') || 'Search by Campaign'}
      </div>

      <h6 style={{fontSize: 14, marginTop: 5}}>{t('menu.searchCampaigns') || 'Buscar campañas'}:</h6>
      <input
        type="text"
        value={search}
        onChange={(e) => setSearch(e.target.value)}      // ← controla "search"
        placeholder={t('menu.typeCampaignName') || 'Campaign name'}
        style={{ width: '100%', padding: 10, fontSize: 12, borderRadius: 5, marginTop: 10 }}
        autoFocus
      />

      {loading && <div style={{textAlign:'center', padding:10}}>{(t('common.searching') || 'Searching') + '...'}</div>}

      {!loading && campaigns.length > 0 && (
        <div style={{ marginTop: 10, maxHeight: 300, overflowY: 'auto' }}>
          {campaigns.map((c) => (
            <div key={c.id}
              onClick={() => handlePick(c)}
              style={{ padding: 8, cursor:'pointer', borderBottom: '1px solid #eee', marginTop: 10 }}>
              <div style={{fontWeight: 600}}>{c.name}</div>
              <div style={{fontSize:12, color:'#666'}}>ID: {c.id}</div>
            </div>
          ))}
        </div>
      )}

      {!loading && campaigns.length === 0 && (
        <div style={{fontSize:12, color:'#666', marginTop:10}}>
          {t('common.noResults') || 'Sin resultados'}
        </div>
      )}

      {searchResultsContainer && <div ref={searchResultsContainer} />}
    </div>
  );
};

export default SearchCampaign;
